import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { formatDate, formatNumber } from '../../../utils/util';

import { requestViewAdminContracts } from '../../../api/contract/contract.actions';
import { requestViewAllFacilitators } from '../../../api/party/party.actions';
import { requestViewAllSpecifications } from '../../../api/product/product.actions';
import { setInitialFilters } from '../../../slices/admin/deal-room-management/deal-room-management.slice';

import DealRoomManagement from '../../../components/screens/admin/deal-room-manangement/DealRoomManagement';

const DealRoomManagementContainer = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [mappedContracts, setMappedContracts] = useState([]);

  const { facilitators } = useSelector(({ party }) => party);
  const { adminContracts } = useSelector(({ contract }) => contract);
  const { initialFilters } = useSelector(({ dealRoomManagement }) => dealRoomManagement);
  const { specifications } = useSelector(({ product }) => product);

  const dispatch = useDispatch();

  const retrieveContracts = useCallback(
    (filters) => {
      dispatch(
        requestViewAdminContracts({
          filters: {
            page: filters.page,
            recordsPerPage: filters.recordsPerPage.value,
            name: filters.searchString,
            status: filters.status?.value,
            contractDateFrom: filters.initiatedFrom,
            contractDateTo: filters.initiatedTo,
            minimumPrice: filters.minimumPrice,
            maximumPrice: filters.maximumPrice,
            facilitatorVO: filters.facilitator ?? {},
            productVO: filters.product ?? {},
          },
          onSuccess: (totalContracts) => {
            setTotalPages(Math.ceil(totalContracts / filters.recordsPerPage.value));
            setCurrentPage(filters.page);
          },
        })
      );
      dispatch(setInitialFilters(filters));
    },
    [dispatch]
  );

  useEffect(() => {
    const filters = {
      page: 0,
      recordsPerPage: 1000,
    };

    dispatch(requestViewAllSpecifications({ filters }));
    dispatch(requestViewAllFacilitators());
  }, [dispatch]);

  useEffect(() => {
    retrieveContracts(initialFilters);
  }, [dispatch, retrieveContracts, initialFilters]);

  useEffect(() => {
    if (!adminContracts) return;

    const mappedContracts = adminContracts.map((contract) => ({
      externalReference: contract.contractExternalReference,
      deal: `#${contract.dealNumber}`,
      status: contract.assistanceRequired ? <p style={{ color: 'red' }}>ASSISTANCE</p> : contract.status,
      product: contract.product.name,
      facilitator: contract.facilitator.name,
      price: formatNumber(contract.price),
      date: formatDate(contract.date),
      version: `v${contract.version.split('.')[1]}`,
    }));

    setMappedContracts(mappedContracts);
  }, [adminContracts]);

  return (
    <DealRoomManagement
      contracts={mappedContracts}
      products={specifications.map((specification) => specification.type)}
      facilitators={facilitators}
      initialFilters={initialFilters}
      currentPage={currentPage}
      totalPages={totalPages}
      retrieveContracts={retrieveContracts}
    />
  );
};

export default DealRoomManagementContainer;
